if (!customElements.get('help-and-information')) {
  class HelpAndInformation extends HTMLElement {
    constructor() {
      super();
      this.selectPanel = this.selectPanel.bind(this);
      this.handleSearch = this.handleSearch.bind(this);
    }

    connectedCallback() {
      this.searchInput = this.querySelector('[data-hfaq-search]');
      this.navBtns = Array.from(this.querySelectorAll('[data-hfaq-nav-btn]'));
      this.panels = Array.from(this.querySelectorAll('[data-hfaq-panel]'));
      this.items = Array.from(this.querySelectorAll('[data-hfaq-item]'));
      this.results = this.querySelector('[data-hfaq-results]');
      this.noResults = this.querySelector('[data-hfaq-no-results]');

      this._panelItems = new Map();
      this.panels.forEach((panel) => this._panelItems.set(panel, Array.from(panel.querySelectorAll('[data-hfaq-item]'))));

      this._setActivePanel(this.panels.find((panel) => panel.classList.contains('is-active')) || this.panels[0]);

      this.navBtns.forEach((btn) => btn.addEventListener('click', () => this._onNavClick(btn.dataset.topicPanel)));
      if (this.searchInput) {
        this.searchInput.addEventListener('input', (event) => this.handleSearch(event.target.value));
      }
    }

    _onNavClick(id) {
      if (this.classList.contains('help-info--searching')) {
        if (this.searchInput) this.searchInput.value = '';
        this._restoreItems();
        this.classList.remove('help-info--searching');
        if (this.noResults) this.noResults.hidden = true;
      }
      this.selectPanel(id);
    }

    selectPanel(id) {
      this.navBtns.forEach((btn) => {
        const active = btn.dataset.topicPanel === id;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.topicPanel === id));
      this._setActivePanel(this.panels.find((panel) => panel.dataset.topicPanel === id));
    }

    _setActivePanel(panel) {
      this._activePanel = panel;
    }

    handleSearch(query) {
      const q = (query || '').trim().toLowerCase();
      this._restoreItems();

      if (!q || !this.items.length) {
        this.classList.remove('help-info--searching');
        if (this.noResults) this.noResults.hidden = true;
        this.selectPanel(this._activePanel ? this._activePanel.dataset.topicPanel : 0);
        return;
      }

      this.classList.add('help-info--searching');
      this.panels.forEach((panel) => panel.classList.remove('is-active'));
      if (this.noResults) this.noResults.hidden = true;

      const matches = this.items.filter((item) => this._matches(item, q));
      if (this.results) {
        matches.forEach((item) => this._appendResult(item));
      }
      if (this.noResults) this.noResults.hidden = matches.length > 0;
    }

    _matches(item, q) {
      const question = (item.querySelector('.help-info__question') || item).textContent.toLowerCase();
      const answer = (item.querySelector('.content') || item).textContent.toLowerCase();
      const topic = (item.dataset.topicName || '').toLowerCase();
      return question.includes(q) || answer.includes(q) || topic.includes(q);
    }

    _appendResult(item) {
      const label = document.createElement('p');
      label.className = 'help-info__result-topic';
      label.textContent = item.dataset.topicName || '';
      this.results.appendChild(label);
      this.results.appendChild(item);
    }

    _restoreItems() {
      if (!this._panelItems) return;
      this._panelItems.forEach((items, panel) => {
        items.forEach((item) => panel.appendChild(item));
      });
      if (this.results) this.results.innerHTML = '';
    }
  }

  customElements.define('help-and-information', HelpAndInformation);
}
